// extracted by mini-css-extract-plugin
export default {"page":"TechnicalSupportPage_page__yEC6F","container":"TechnicalSupportPage_container__8UEZg"};